import { createAsyncThunk } from '@reduxjs/toolkit'
import jwtDecode from 'jwt-decode'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'
import CookiesStorageService from '../../../services/CookiesStorageService'
import { loadTranslationsFile } from '../languageTranslation/languageThunk'

const userAuthLoginApi = Configuration.Auth_Endpoints
const logoutPath = `${Configuration.USER_MANAGEMENT_BASE_URL}/${Configuration.Auth_Endpoints.logout}`

export const userAuthResetAlertHandler = createAsyncThunk(
  'userAuth/userAuthResetAlertHandler',
  async () => ({}),
)
export const userAuthTokenDecode = createAsyncThunk(
  'userAuth/userAuthTokenDecode',
  async ({ queries }) => jwtDecode(queries.token),
)

export const userAuthLogin = createAsyncThunk(
  'userAuth/userAuthLogin',
  async ({ queries }, { rejectWithValue, dispatch }) => {
    const response = await RestClient.postRequest(userAuthLoginApi.login, queries)

    if (response.status >= 300) {
      return rejectWithValue({
        status: 401,
        message: response.message || response.status === 401
          ? 'Incorrect Login name  or password'
          : 'oops something went wrong please try again later',

        timestamp: response.timestamp,
        severity: 'error',
      })
    }

    CookiesStorageService.setUserData(response.data)

    dispatch(loadTranslationsFile())

    return response.data
  },
)

export const userAuthLogout = createAsyncThunk(
  'userAuth/userAuthLogout',
  async (_, { dispatch }) => {
    const query = {
      token: CookiesStorageService.getAccessToken(),
      refresh_token: CookiesStorageService.getAccessRefreshToken(),
    }

    const response = await RestClient.postRequest(logoutPath, query)

    if (response.status === 200) {
      CookiesStorageService.clearCookies()
      dispatch(clearAuthorizedUser())
    }

    return response.data
  },
)

export const userAuthResetPassword = createAsyncThunk(
  'userAuth/userAuthResetPassword',
  async ({ queries }, { rejectWithValue }) => {
    const response = await RestClient.postRequest(userAuthLoginApi.resetPasswordApply, queries)

    if (response.status > 201) {
      return rejectWithValue({
        status: 401,
        message: 'Incorrect password',
        timestamp: response.timestamp,
        severity: 'error',
      })
    }

    return {
      status: 201,
      message: 'Successfully updated your password',
    }
  },
)
export const sendForgetPasswordEmail = createAsyncThunk(
  'userAuth/sendForgetPasswordEmail',
  async ({ queries }, { rejectWithValue }) => {
    const response = await RestClient.postRequest(userAuthLoginApi.sendForgetPasswordEmail, queries)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return response.data
  },
)
export const validateResetPasswordToken = createAsyncThunk(
  'userAuth/validateResetPasswordToken',
  async ({ queries }, { rejectWithValue }) => {
    const response = await RestClient.postRequest(`${userAuthLoginApi.sendForgetPasswordEmail}/${queries}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return response.status
  },
)

export const userResetPassword = createAsyncThunk(
  'userAuth/userResetPassword',
  async ({ queries }, { rejectWithValue, getState }) => {
    const response = await RestClient.putRequest(userAuthLoginApi.sendForgetPasswordEmail, queries)
    const { language } = getState()
    if (response.status > 201) {
      return rejectWithValue({
        status: 401,
        message: response.message,
        timestamp: response.timestamp,
        severity: 'error',
      })
    }

    return {
      status: 201,
      message: language?.translations?.['Successfully updated your password'],
    }
  },
)

export const userAuthResetCheckToken = createAsyncThunk(
  'userAuth/userAuthResetCheckToken',
  async ({ queries }, { rejectWithValue }) => {
    const response = await RestClient.postRequest(
      `${userAuthLoginApi.resetPasswordValidate}?token=${queries}`,
    )

    const requestUrl = response.config.url

    if (requestUrl.includes('validation') && response.status > 201) {
      return rejectWithValue({
        status: 401,
        message: 'Reset mail is expired please contact system administrator to reset your password',
        timestamp: response.timestamp,
        severity: 'error',
      })
    }

    return {
      status: 200,
      message: 'Token is Valid',
    }
  },
)

export const userAuthValidateToken = createAsyncThunk(
  'userAuth/userAuthValidateToken',
  async () => {
    await RestClient.postRequest(`${userAuthLoginApi.validateToken}`, {
      token: CookiesStorageService.getAccessToken(),
      refresh_token: CookiesStorageService.getAccessRefreshToken(),
    })

    return {
      status: 200,
      message: 'Token is Valid',
    }
  },
)

export const clearAlertStore = createAsyncThunk('userAuth/clearAlertStore', async () => ({}))

export const clearAuthorizedUser = createAsyncThunk(
  'userAuth/clearAuthorizedUser',
  async () => ({}),
)

export const userAuthChangePassword = createAsyncThunk(
  'userAuth/userAuthChangePassword',
  async ({ queries }, { rejectWithValue }) => {
    const response = await RestClient.patchRequest(userAuthLoginApi.editUser, queries)
    if (response.status > 201) {
      return rejectWithValue({
        status: 401,
        message: response.message || 'Incorrect Login name  or password',
        timestamp: response.timestamp,
        severity: 'error',
      })
    }

    return {
      status: 201,
      message: 'Successfully updated your password',
    }
  },
)

export const userCustomerAdminAuthChangePassword = createAsyncThunk(
  'userAuth/userAuthChangePassword',
  async ({ queries, userId }, { rejectWithValue }) => {
    const response = await RestClient.putRequest(`companies/users/${userId}/modify-password`, queries)

    if (response.status > 201) {
      return rejectWithValue({
        status: 401,
        message: response.message || 'Incorrect Login name  or password',
        timestamp: response.timestamp,
        severity: 'error',
      })
    }

    return {
      status: 201,
      message: 'Successfully updated your password',
    }
  },
)
